export const FEE_BALANCE_NAME_MAX_LENGTH = 64;

const UNSAFE_CHARACTER_PATTERN = /\p{C}/u;
const VISIBLE_CHARACTER_PATTERN = /[\p{L}\p{N}\p{P}\p{S}]/u;

export function normalizeFeeBalanceName(value: string): string | undefined {
  const normalized = value.normalize('NFKC').replace(/\s+/g, ' ').trim();
  if (!normalized) return '';
  if (Array.from(normalized).length > FEE_BALANCE_NAME_MAX_LENGTH) return undefined;
  if (UNSAFE_CHARACTER_PATTERN.test(normalized) || !VISIBLE_CHARACTER_PATTERN.test(normalized)) return undefined;
  return normalized;
}
